import { PropsWithChildren, ReactNode } from 'react';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

// Use `type` instead of `interface` and `PropsWithChildren` for children typing
type TextOldProps = PropsWithChildren<{
  color?: string;
  textAlign?: 'left' | 'center' | 'right';
  textDecoration?: string;
  fontSize?: number;
  fontWeight?: number;
  className?: string;
  pb?: number;
  pt?: number;
  pl?: number;
  pr?: number;
  mt?: number;
  mb?: number;
  ml?: number;
  mr?: number;
}>;

/**
 * @deprecated
 * Use `Text` instead.
 */
export const TextOld = ({
  children,
  color = COLORS.textMain,
  textAlign = 'left',
  textDecoration,
  fontSize = 15,
  fontWeight = 500,
  className,
  pb,
  pt,
  pl,
  pr,
  mt,
  mb,
  ml,
  mr,
}: TextOldProps) => {
  return (
    <StyledText
      className={className}
      $color={color}
      $textAlign={textAlign}
      $textDecoration={textDecoration}
      $fontSize={fontSize}
      $fontWeight={fontWeight}
      $pb={pb}
      $pt={pt}
      $pl={pl}
      $pr={pr}
      $mt={mt}
      $mb={mb}
      $ml={ml}
      $mr={mr}
    >
      {children}
    </StyledText>
  );
};

// Styled component for TextOld
const StyledText = styled('p')((props: any) => {
  return {
    fontSize: props.$fontSize,
    color: props.$color,
    fontWeight: props.$fontWeight,
    textAlign: props.$textAlign,
    textDecoration: props.$textDecoration,
    paddingBottom: props.$pb,
    paddingTop: props.$pt,
    paddingLeft: props.$pl,
    paddingRight: props.$pr,
    marginBottom: props.$mb,
    marginTop: props.$mt,
    marginLeft: props.$ml,
    marginRight: props.$mr,
  };
});
